// extracted by mini-css-extract-plugin
module.exports = {"CaregiversHome":"caregivers_CaregiversHome__flfCQ"};